"use client";

import {redirect} from "next/navigation";
import {useEffect} from "react";

const ClientRedirect = ({to}: {to: string}) => {
	useEffect(() => {
		redirect(to);
	}, [to]);

	return null;
};

export default ClientRedirect;
